import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ServiceAudienceComponent extends Component {
  static readonly TYPE_ID: string = 'b3bdbc6ee18b4642b001b233cdc5d11a';

  constructor(
        public readonly adultsOnly: boolean,
        public readonly availableForMen: boolean,
        public readonly availableForWomen: boolean,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ServiceAudienceComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServiceAudienceComponent {
    return new ServiceAudienceComponent(
        MapUtils.get<boolean>(map, 'adultsOnly'),
        MapUtils.get<boolean>(map, 'availableForMen'),
        MapUtils.get<boolean>(map, 'availableForWomen'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'adultsOnly': this.adultsOnly,
      'availableForMen': this.availableForMen,
      'availableForWomen': this.availableForWomen,
    };
  }

  clone(): this {
    return new ServiceAudienceComponent(
        this.adultsOnly,
        this.availableForMen,
        this.availableForWomen,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.adultsOnly === this.adultsOnly &&
        other.availableForMen === this.availableForMen &&
        other.availableForWomen === this.availableForWomen;
  }
}

export class ServiceAudienceComponentBuilder extends DataModelBuilder<ServiceAudienceComponent> {
  build(context: SerializationContext, map: SerializedData): ServiceAudienceComponent {
    return ServiceAudienceComponent.fromMap(context, map);
  }
}
